import React from 'react';
import { Flex, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('login.ResetPassword');
export default function ExpiredActivationCodeInstructionComponent(props) {
  const {
    submitted
  } = props;
  return /*#__PURE__*/React.createElement(Flex, {
    variant: "colM"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "formTitle|title"
  }, submitted ? t('titleSuccess') : t('title')), /*#__PURE__*/React.createElement(Text, {
    variant: "formBody"
  }, submitted ? t('instructionSuccess') : t('instruction')));
}